var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Hidden from '@material-ui/core/Hidden';
var HiddenNext = function (props) { return React.createElement(Hidden, __assign({}, props)); };
export default HiddenNext;
//# sourceMappingURL=index.js.map